import {
    Days,
    Hours,
    Minutes,
    MinutesShort,
    Seconds,
    SecondsShort
} from 'autogen/translation-keys/trans-website-countdown';
import {
    DayShorthand,
    HourShorthand,
    MinuteShorthand,
    SecondShorthand
} from 'autogen/translation-keys/trans-website-shared';

export function timeDifference({ startDate, finishDateTime }): number {
    const difference = new Date(finishDateTime).getTime() - new Date(startDate).getTime();

    return difference;
}

export function calculateTimeLeft(
    millisecondsLeft: number,
    displayType?: string,
    dayToHourThresholdMilliseconds?: number
) {
    let timeLeft = { displayFormat: 'days', days: 0, hours: 0, minutes: 0, seconds: 0 };

    if (
        (dayToHourThresholdMilliseconds && millisecondsLeft < dayToHourThresholdMilliseconds) ||
        (displayType === 'Hours' && !dayToHourThresholdMilliseconds)
    ) {
        timeLeft = {
            displayFormat: 'hours',
            days: 0,
            hours: Math.floor(millisecondsLeft / (1000 * 60 * 60)),
            minutes: Math.floor((millisecondsLeft / 1000 / 60) % 60),
            seconds: Math.max(Math.floor((millisecondsLeft / 1000) % 60), 0)
        };
    } else {
        timeLeft = {
            displayFormat: 'days',
            days: Math.floor(millisecondsLeft / (1000 * 60 * 60 * 24)),
            hours: Math.floor((millisecondsLeft / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((millisecondsLeft / 1000 / 60) % 60),
            seconds: Math.max(Math.floor((millisecondsLeft / 1000) % 60), 0)
        };
    }

    return timeLeft;
}

export function generateTranslations(sizeType) {
    switch (sizeType) {
        case 'XS':
            return {
                seconds: SecondShorthand,
                minutes: MinuteShorthand,
                hours: HourShorthand,
                days: DayShorthand
            };
        case 'XL':
            return {
                days: Days,
                hours: Hours,
                seconds: Seconds,
                minutes: Minutes
            };
        default:
            return {
                days: Days,
                hours: Hours,
                seconds: SecondsShort,
                minutes: MinutesShort
            };
    }
}

export function generateNumbers(sizeType, time) {
    const { days, hours, minutes, seconds } = time;

    const showDays = days > 0;
    const showHours = hours > 0 || showDays;
    const showMinutes = minutes > 0 || showHours;

    switch (sizeType) {
        case 'XS':
            return {
                daysArray: showDays && days.toString().padStart(2, '0').split(''),
                hoursArray: showHours && hours.toString().padStart(2, '0').split(''),
                minutesArray: showMinutes && minutes.toString().padStart(2, '0').split(''),
                secondsArray: seconds > 0 ? seconds.toString().padStart(2, '0').split('') : [0]
            };
        default:
            return {
                daysArray: days > 0 ? days.toString().padStart(2, '0').split('') : [0, 0],
                hoursArray: hours > 0 ? hours.toString().padStart(2, '0').split('') : [0, 0],
                minutesArray: minutes > 0 ? minutes.toString().padStart(2, '0').split('') : [0, 0],
                secondsArray: seconds > 0 ? seconds.toString().padStart(2, '0').split('') : [0, 0]
            };
    }
}
